import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import "./index.css";

/* ===========================================================
 🚀 React Root (React 18)
=========================================================== */
const container = document.getElementById("root");

if (!container) {
  throw new Error("❌ Root element (#root) غير موجود في index.html");
}

const root = ReactDOM.createRoot(container);

/* ===========================================================
 🌍 Render App داخل BrowserRouter
  - basename="/" مناسب للسيرفر الحالي
=========================================================== */
root.render(
  <React.StrictMode>
    <BrowserRouter basename="/">
      <App />
    </BrowserRouter>
  </React.StrictMode>
);

/* ===========================================================
 📱 PWA - Service Worker
=========================================================== */
if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/service-worker.js")
      .then((registration) => {
        console.log("✅ Service Worker تم تسجيله بنجاح:", registration.scope);
      })
      .catch((error) => {
        console.error("❌ فشل تسجيل Service Worker:", error);
      });
  });
}
